import globalEnv from '~/config/env';
import { useVisibilityForLegacyUrl } from '~/components/LegacyAppRouting/components/Learner';
import { useUserAuth } from '~/components/Auth';

export default function useHeaderOffset() {
  const { company } = useUserAuth();

  const isVisibleForLegacyApp = useVisibilityForLegacyUrl(
    globalEnv.LEGACY_WHITELISTED_HEADER_ROUTES
  );

  const isVisible = !company?.companySettings?.isExperienceCloudEnabled && isVisibleForLegacyApp;
  return isVisible ? 57 : 0;
}
